import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCorporateBankAccountSearch = () => {
  const corporateBankAccountSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/corporate/bank-account/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { corporateBankAccountSearch }
}

export default InteractorCorporateBankAccountSearch
